// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 重置一些默认样式 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, sans-serif;
}

.app-container {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 250px;
  background-color: #2c3e50;
  color: white;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar h2 {
  margin-top: 0;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  padding: 10px 0;
  cursor: pointer;
}

.sidebar li:hover {
  color: #3498db;
}

.main-content {
  flex: 1 1;
  padding: 20px;
  background-color: #ecf0f1;
  overflow-y: auto;
}

/* 添加active类样式 */
.sidebar li.active {
  color: #3498db;
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.1);
  border-left: 3px solid #3498db;
  padding-left: 17px; /* 原来的padding是20px，减去3px边框 */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,iBAAiB;EACjB,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB,EAAE,4BAA4B;AAClD","sourcesContent":["/* 重置一些默认样式 */\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: Arial, sans-serif;\n}\n\n.app-container {\n  display: flex;\n  height: 100vh;\n}\n\n.sidebar {\n  width: 250px;\n  background-color: #2c3e50;\n  color: white;\n  padding: 20px;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar h2 {\n  margin-top: 0;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar li {\n  padding: 10px 0;\n  cursor: pointer;\n}\n\n.sidebar li:hover {\n  color: #3498db;\n}\n\n.main-content {\n  flex: 1;\n  padding: 20px;\n  background-color: #ecf0f1;\n  overflow-y: auto;\n}\n\n/* 添加active类样式 */\n.sidebar li.active {\n  color: #3498db;\n  font-weight: bold;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-left: 3px solid #3498db;\n  padding-left: 17px; /* 原来的padding是20px，减去3px边框 */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
